import { useGetCategoriesQuery } from '../../utils/callApis';
import { Box } from '@material-ui/core';
import { useSelector } from 'react-redux';
import CategoryExcerpt from './CategoryExcerpt';
import layout from '../../styles/layout.module.css';

import { useRef } from 'react';
export const CategoryList = () => {
    const { data: categories, isLoading, isSuccess, isError, error } = useGetCategoriesQuery();
    let currCategory = useSelector((state) => state.rootReducer.currentCategory.activeCategory);
    let summaryCategoryState = useSelector(
        (state) => state.rootReducer.summaryCategoryState.summaryState
    );
    let navContainerRef = useRef(null);

    const handleMobileScroll = (index) => {
        const scrollContainer = navContainerRef.current;
        const button = scrollContainer.childNodes[index];
        const containerWidth = scrollContainer.offsetWidth;
        const buttonOffset = button.offsetLeft;
        const buttonWidth = button.offsetWidth;
        const scrollTo = buttonOffset - (containerWidth - buttonWidth) / 2;

        scrollContainer.scrollTo({
            left: scrollTo,
            behavior: 'smooth'
        });
    };

    let content;
    if (isLoading && !categories) {
        content = <p>Loading...</p>;
    } else if (isSuccess) {
        const newCategories = [...categories].map((category) => {
            if (category.displayName === 'SUMMARY') {
                return { ...category, displayOrder: '8' };
            }
            return category;
        });

        newCategories.push({
            displayName: 'CARE_PLAN',
            displayOrder: '7',
            id: 'care_plan_category'
        });

        newCategories.sort((a, b) => parseInt(a.displayOrder) - parseInt(b.displayOrder));

        content = (
            <div className={layout.navContainer} id="navContainer" ref={navContainerRef}>
                {newCategories.map((category, index) => (
                    <CategoryExcerpt
                        key={index}
                        index={index}
                        currCategory={currCategory}
                        category={category}
                        summaryState={summaryCategoryState}
                        handleMobileScroll={handleMobileScroll}
                    />
                ))}
            </div>
        );
    } else if (isError) {
        content = <div>{error.toString()}</div>;
    }
    return <Box className={layout.flexColContainer}>{content}</Box>;
};
